import '../assets/styles/SchoolServices.css';

export default function SchoolServices() {
  const beneficios = [
  {
  id: 1,
  icon: "🌿",
  title: "Manutenção Regular",
  description: "Oferecemos serviços programados de manutenção para garantir que suas instalações estejam sempre em perfeito estado, evitando problemas futuros e preservando o patrimônio."
},
{
  id: 2,
  icon: "🛡️",
  title: "Segurança",
  description: "Priorizamos a segurança em todos os serviços prestados, eliminando riscos e garantindo ambientes seguros para funcionários, clientes e usuários."
},
{
  id: 3,
  icon: "📅",
  title: "Planejamento Escolar",
  description: "Trabalhamos com cartão CPESC e PDDE, ajustando nossos horários às necessidades operacionais do cliente para não interferir em suas atividades diárias."
},
{
  id: 4,
  icon: "⚡",
  title: "Agilidade",
  description: "Executamos os serviços com rapidez e eficiência, contando com equipe capacitada e comprometida em entregar resultados no prazo estabelecido."
},
{
  id: 5,
  icon: "♻️",
  title: "Descarte Ecológico",
  description: "Realizamos o descarte adequado de resíduos conforme normas ambientais, contribuindo para práticas sustentáveis e responsabilidade ambiental."
},
{
  id: 6,
  icon: "🔧",
  title: "Equipamentos Adequados",
  description: "Utilizamos ferramentas e equipamentos modernos e apropriados para cada tipo de serviço, garantindo qualidade e segurança na execução."
}
  ];

  return (
    <section id="escolas" className="school-services-section">
      <div className="school-benefits">
        <div className="school-benefits-container">
          <h3>Por que escolher nossos serviços?</h3>
          <div className="benefits-grid">
            {beneficios.map((beneficio) => (
              <div key={beneficio.id} className="benefit-card">
                <div className="benefit-icon">{beneficio.icon}</div>
                <h4>{beneficio.title}</h4>
                <p>{beneficio.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}